import { createStyles, makeStyles } from '@material-ui/core';
import { NoEncryption } from '@material-ui/icons';

export const useStyles = makeStyles((theme) =>
  createStyles({
    chipContainer: {
      padding: 30,
      display: 'flex',
      flexDirection: 'column',
      '& .MuiChip-root': {
        margin: '0 5px 10px 0',
      },
    },
    dialogContentContainer: {
      padding: '8px 24px 24px',
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '10px',
      marginTop: '20px',
    },
    subHeading: {
      // fontWeight: '',
    },
    groupAccordion: {
      backgroundColor: 'transparent',
      '&.MuiPaper-root': {
        boxShadow: 'none',
        margin: '5px 0 0',
        '&:before': {
          display: 'none',
        },
      },
      '& .MuiAccordionSummary-content': {
        margin: '0',
      },
      '& .MuiAccordionSummary-root.Mui-expanded': {
        minHeight: 'unset',
      },
      '& .MuiAccordionSummary-root': {
        padding: '0',
        borderBottom: '1px solid #2d343e',
        minHeight: 'unset',
        marginBottom: 10,
      },
      '& .MuiIconButton-edgeEnd': {
        marginRight: '0',
      },
      '& .MuiAccordionDetails-root': {
        padding: '10px 0 0',
      },
      '& .MuiIconButton-root': {
        padding: '0',
      },
    },
  }),
);

import { styled, Button, DialogContent, Grid, Theme } from '@material-ui/core';
import { StyledDialog } from '@room-match/shared-ui-components';
import { COLORS } from 'shared/constants/COLORS';

export const CloseButton = styled(Button)({
  position: 'absolute',
  top: '20px',
  right: '20px',
  cursor: 'pointer',
  minWidth: 'unset',
  borderRadius: '100%',
  width: 30,
  height: 30,
  background: 'none',
});

export const CustomDialog = styled(StyledDialog)({
  '&.paper': {
    minWidth: '85%',
    minHeight: '90%',
  },
  '& .MuiDialog-paperWidthSm': {
    minHeight: 600,
    maxWidth: 700,
  },
});

export const CustomDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: '40px 70px 50px!important',
  background: '#0d1117',
  display: 'flex',
  flexDirection: 'column',
  height: 600,

  [theme.breakpoints.down('xs')]: {
    padding: '40px 25px 50px!important',
  },
}));

export const Header = styled('div')({
  marginBottom: 30,
  textAlign: 'center',
});

export const ActionsContainer = styled('div')(({ theme }) => ({
  marginTop: 'auto',
  display: 'flex',
  gap: 15,
}));

export const CustomButton = styled(Button)<Theme, { isEdit?: boolean }>(({ isEdit }) => ({
  borderRadius: 5,
  background: isEdit ? COLORS.PRIMARY : '#0c121b',
  border: '1px solid',
  borderColor: COLORS.PRIMARY,
  height: 44,
  fontSize: 16,
}));
